<app-modal
  #modal
  [modalConfig]="modalConfig"
  (isDismissing)="reset()"
  (isClosing)="reset()">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    [disabled]="uploadSaving"
    (click)="modal.dismiss()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="container">
    <div class="row">
      <div class="col-12 my-3">
        <input
          #uploadFileInput
          type="file"
          style="display: none"
          multiple
          accept=".pdf,.csv,.doc,.docx,.xls,.xlsx,.html,.txt,.md,.gif,.jpeg,.jpg,.png,.mp4"
          (change)="onUploadFileChange($event)" />
        <input
          #uploadFolderInput
          type="file"
          style="display: none"
          webkitdirectory
          (change)="onUploadFolderChange($event)" />
        <div
          class="upload-dropzone p-3 text-center rounded-1"
          [class.upload-dropzone--active]="uploadDropzoneActive"
          [class.upload-dropzone--disabled]="uploadSaving"
          (dragover)="$event.preventDefault(); uploadDropzoneActive = true"
          (dragleave)="$event.preventDefault(); uploadDropzoneActive = false"
          (dragend)="$event.preventDefault(); uploadDropzoneActive = false"
          (drop)="handleUploadFileDrop($event)">
          <p class="color-dark-gray fw-bold mb-2">
            Drag files or folders here, or:
          </p>
          <div class="d-flex gap-2 justify-content-center">
            <button
              type="button"
              class="btn btn-primary"
              [disabled]="uploadSaving"
              (click)="uploadFileInput.click()">
              <i class="bi bi-file-earmark-plus"></i> Files
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              [disabled]="uploadSaving"
              (click)="uploadFolderInput.click()">
              <i class="bi bi-folder-plus"></i> Folder
            </button>
          </div>
        </div>

        <div
          *ngIf="uploadErrorMessage"
          class="alert alert-danger text-start mt-3 mb-0 d-flex justify-content-between"
          role="alert">
          {{ uploadErrorMessage }}
          <button
            type="button"
            class="btn-close"
            (click)="uploadErrorMessage = ''"
            data-bs-dismiss="alert"
            aria-label="Close"></button>
        </div>
        <div *ngIf="stagedFiles.length > 0" class="file-list mt-2">
          <ng-container *ngFor="let group of groupedStagedFiles">
            <!-- Folder group header -->
            <div
              *ngIf="group.folderName"
              class="folder-group-header d-flex align-items-center justify-content-between py-2 px-1 border-bottom border-primary-subtle">
              <div class="d-flex align-items-center gap-2">
                <i class="bi bi-folder-fill text-warning fs-21"></i>
                <span class="fw-600">{{ group.folderName }}</span>
                <small class="text-muted"
                  >({{ group.items.length }} files)</small
                >
              </div>
              <div>
                <i
                  *ngIf="groupStatus(group) === 'done'"
                  class="bi bi-check-lg text-success fs-21"></i>
                <i
                  *ngIf="groupStatus(group) === 'error'"
                  class="bi bi-x-circle text-danger fs-21"></i>
                <span
                  *ngIf="groupStatus(group) === 'uploading'"
                  class="spinner-border spinner-border-sm text-primary"
                  role="status"></span>
              </div>
            </div>
            <ngb-progressbar
              *ngIf="
                group.folderName &&
                (groupStatus(group) === 'uploading' ||
                  groupStatus(group) === 'done')
              "
              [value]="groupProgress(group)"
              [animated]="groupStatus(group) === 'uploading'"
              class="mb-1"></ngb-progressbar>

            <!-- Files in group -->
            <div
              *ngFor="let item of group.items"
              class="d-flex flex-column border-bottom border-black-subtle py-2"
              [class.ps-4]="group.folderName">
              <div
                class="d-flex flex-row justify-content-between align-items-center">
                <div class="file-name">
                  <i
                    class="bi {{
                      getFileIcon(item.staged.file.name)
                    }} color-tertiary fs-21 me-1 d-inline-block"></i>
                  <span
                    [title]="
                      group.folderName
                        ? getFileRelativeName(item.staged, group.folderName)
                        : item.staged.file.name
                    "
                    >{{
                      group.folderName
                        ? getFileRelativeName(item.staged, group.folderName)
                        : item.staged.file.name
                    }}</span
                  >
                </div>
                <button
                  *ngIf="item.staged.status === 'pending'"
                  class="btn-delete"
                  ngbTooltip="Remove"
                  aria-label="Remove file"
                  (click)="removeStagedFile(item.originalIndex)">
                  <i class="bi fs-21 bi-trash"></i>
                </button>
                <i
                  *ngIf="item.staged.status === 'done'"
                  class="bi bi-check-lg text-success fs-21"></i>
                <i
                  *ngIf="item.staged.status === 'error'"
                  class="bi bi-x-circle text-danger fs-21"></i>
              </div>
              <ngb-progressbar
                *ngIf="
                  !group.folderName &&
                  (item.staged.status === 'uploading' ||
                    item.staged.status === 'done')
                "
                class="mt-1"
                [value]="item.staged.progress"
                [animated]="
                  item.staged.status === 'uploading'
                "></ngb-progressbar>
              <small
                *ngIf="item.staged.status === 'error'"
                class="text-danger mt-1">
                {{ item.staged.errorMsg }}
              </small>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-between" footerContent>
    <button
      type="button"
      class="btn btn-reset"
      [disabled]="uploadSaving"
      (click)="modal.dismiss()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!stagedFiles.length || uploadSaving"
      (click)="saveUploadFiles()">
      <span
        *ngIf="uploadSaving"
        class="spinner-border spinner-border-sm me-1"
        role="status"
        aria-hidden="true"></span>
      {{ uploadSaving ? "Uploading..." : "Upload" }}
    </button>
  </div>
</app-modal>
